import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { AuthServicesService } from 'src/app/services/auth-services.service';
import { FirebaseFunctionsService } from 'src/app/services/firebase-functions.service';

@Component({
  selector: 'app-menu-admin',
  templateUrl: './menu-admin.component.html',
  styleUrls: ['./menu-admin.component.scss']
})
export class MenuAdminComponent implements OnInit {

  userData: any = {};
  imgUrl: Observable<any>;
  userTempsFort: any;
  imgGot: boolean = false;
  constructor(private  route: Router, private afs: FirebaseFunctionsService, private authService: AuthServicesService, public app: AppComponent) { 
    this.getUserData();
  }

  ngOnInit(): void {
  }
  getUserData(){
    const uid = sessionStorage.getItem('userId');
    if(uid!=null){
      this.afs.getUtilisateur(uid).forEach( user => {
        this.userData = user;
        this.afs.getProfilePicture(uid).subscribe( imgs => {
          this.imgUrl = this.afs.getImgUrlFromFireStorage(`/utilisateurs/${uid}/profilePicture/${imgs.items[0]['name']}`);
          this.imgGot = (imgs.items.length < 1)? false: true;
        });
      });
      this.afs.getUserStarTemps(uid).subscribe( temps => {
        this.userTempsFort = temps;
      });
    }else{
      this.app.navigateTo('/');
    }
  }
  manageDropDown(): void {
    const dorpDownDiv = document.querySelector('.menu_dropdown') as HTMLElement;
    dorpDownDiv.style.display = (dorpDownDiv.style.display == 'block') ? 'none' : 'block';
  }
  go(url:string){
    this.route.navigateByUrl(url);
  }
  signOut(){
    this.authService.signOut();
  }
}
